import { gql } from "../../__generated__";

export const NEW_INVEST_LEAD = gql(`
  mutation NewInvestLead($lead: InvestLeadPayload!, $notes: String!) {
    newInvestLead(lead: $lead, notes: $notes)
  }
`);
